<template>
  <div class="pricing-table">
    <div
        class="pricing-table-inner"
        :class="type.toLowerCase() + '-hero'">
      <div class="pricing-table-main">
        <div
            class="pricing-table-header is-revealing"
            :class="color.toLowerCase()">
          <div
              class="pricing-table-title mt-12 mb-8"
              :class="'text-' + color.toLowerCase()">
            {{ title }}
          </div>
          <div class="pricing-table-price mb-24 pb-24">
            <span
                class="pricing-table-price-amount h2"
                :class="'text-' + color.toLowerCase()">{{ price }}</span>
          </div>
        </div>
        <ul class="pricing-table-features list-reset text-sm text-white">
          <li class="is-revealing">
            <span>{{ list1 }}</span>
          </li>
          <li class="is-revealing">
            <span>{{ list2 }}</span>
          </li>
          <li class="is-revealing">
            <span>{{ list3 }}</span>
          </li>
        </ul>
      </div>
      <div class="pricing-table-cta is-revealing">
        <router-link to="account-registration">
          <a
              class="button button-shadow button-block"
              :class="'button-' + color.toLowerCase()"
              href="http://eepurl.com/gG66OD"
              target="_blank"
              style="color:white !important;">Get started</a>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PricingTable",
  props: [
    'type',
    'color',
    'title',
    'price',
    'list1',
    'list2',
    'list3'
  ]
};
</script>

<style>
</style>
